import { ReactNode } from 'react';
import { CloseCircleFilled } from '@ant-design/icons';
import getFormatMessage from '../../../../locales/get-format-message';
import { OrderStatus } from '../../../../model/api-modules';
import styles from './index.module.scss';
import pendingIcon from '../../../../assets/svg/pending-icon.svg';
import loadingIcon from '../../../../assets/svg/loading-icon.svg';
import successCircle from '../../../../assets/svg/success-circle-fill.svg';
import classNames from 'classnames';

const commonWarn = (
  <div className={styles.desc}>
    <div>{getFormatMessage('order_in_progress')}</div>
    <div>{getFormatMessage('order_in_progress_desc')}</div>
  </div>
);

const getFinalWarn = (statusText: string) => (
  <div className={styles.desc}>
    <div>{getFormatMessage(statusText)}</div>
    <div>{getFormatMessage('order_done_desc')}</div>
  </div>
);

export const OrderStatusConfig: Record<
  number,
  {
    name: string;
    title: string;
    icon: ReactNode;
    desc?: ReactNode;
    listIcon: ReactNode;
    textColor: string;
  }
> = {
  [OrderStatus.NORMAL]: {
    name: getFormatMessage('order_status_normal'),
    title: getFormatMessage('order_completed'),
    icon: <img src={successCircle} />,
    desc: getFinalWarn(getFormatMessage('order_completed')),
    listIcon: (
      <div className={styles.dot} style={{ backgroundColor: '#3EC688' }}></div>
    ),
    textColor: '#1D2129',
  },
  [OrderStatus.CANCEL]: {
    name: getFormatMessage('order_status_cancel'),
    title: getFormatMessage('order_canceled'),
    icon: <CloseCircleFilled />,
    desc: getFinalWarn(getFormatMessage('order_canceled')),
    listIcon: (
      <div className={styles.dot} style={{ backgroundColor: '#C9CDD4' }}></div>
    ),
    textColor: '#1D2129',
  },
  [OrderStatus.REVIEW]: {
    name: getFormatMessage('order_status_review'),
    title: getFormatMessage('order_review'),
    icon: <img src={loadingIcon} className={classNames(styles.loadingIcon)} />,
    desc: commonWarn,
    listIcon: (
      <img
        src={loadingIcon}
        className={classNames(styles.loadingIcon, styles.dot)}
      />
    ),
    textColor: '#1D2129',
  },
  [OrderStatus.LOADING]: {
    name: getFormatMessage('order_status_loading'),
    title: getFormatMessage('order_wait_confirm'),
    icon: <img src={pendingIcon} />,
    desc: commonWarn,
    listIcon: (
      <div className={styles.dot} style={{ backgroundColor: '#F77E45' }}></div>
    ),
    textColor: '#F77E45',
  },
  /* [OrderStatus.OVERDUE]: {
    name: getFormatMessage('欠费'),
    title: getFormatMessage('订单欠费'),
    icon: <CloseCircleFilled />,
    desc: getFinalWarn(getFormatMessage('订单欠费')),
    listIcon: (
      <div className={styles.dot} style={{ backgroundColor: '#C9CDD4' }}></div>
    ),
    textColor: '#1D2129',
  },*/
  [OrderStatus.REVIEW_FAIL]: {
    name: getFormatMessage('order_status_review_fail'),
    title: getFormatMessage('order_review_fail'),
    icon: <CloseCircleFilled />,
    desc: getFinalWarn(getFormatMessage('order_review_fail')),
    listIcon: (
      <div className={styles.dot} style={{ backgroundColor: '#C9CDD4' }}></div>
    ),
    textColor: '#1D2129',
  },
  /*
  [OrderStatus.FAIL]: {
    name: getFormatMessage('交易失败'),
    title: getFormatMessage('订单交易失败'),
    icon: <CloseCircleFilled />,
    desc: getFinalWarn(getFormatMessage('订单交易失败')),
    listIcon: (
      <div className={styles.dot} style={{ backgroundColor: '#C9CDD4' }}></div>
    ),
    textColor: '#1D2129',
  },
	*/
};

export const ORDER_STATUS_OPTIONS = [
  {
    label: getFormatMessage('order_status_review'),
    value: OrderStatus.REVIEW,
  },
  {
    label: getFormatMessage('order_status_loading'),
    value: OrderStatus.LOADING,
  },
  {
    label: getFormatMessage('order_status_normal'),
    value: OrderStatus.NORMAL,
  },
  {
    label: getFormatMessage('order_status_cancel'),
    value: OrderStatus.CANCEL,
  },
  {
    label: getFormatMessage('order_status_review_fail'),
    value: OrderStatus.REVIEW_FAIL,
  },
];
